import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 8 13",
  "content": "<symbol viewBox=\"0 0 8 13\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow\"><path d=\"M1.6 0L0 1.625 4.8 6.5 0 11.375 1.6 13 8 6.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/arrow.svg
// module id = 46
// module chunks = 0